"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomThemeOverride = void 0;
class CustomThemeOverride {
    constructor() {
    }
    static getAttributeTypeMap() {
        return CustomThemeOverride.attributeTypeMap;
    }
}
exports.CustomThemeOverride = CustomThemeOverride;
CustomThemeOverride.discriminator = undefined;
CustomThemeOverride.attributeTypeMap = [
    {
        "name": "borderRadius",
        "baseName": "borderRadius",
        "type": "BorderRadiusConfig",
        "format": ""
    },
    {
        "name": "fontSize",
        "baseName": "fontSize",
        "type": "FontSizeConfig",
        "format": ""
    }
];
//# sourceMappingURL=CustomThemeOverride.js.map